import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// Classic tailwind helper to make it easier to conditionally add tailwind css classes.
// https://tigerabrodi.blog/the-story-behind-tailwinds-cn-function
export default (...inputs) => twMerge(clsx(inputs));
